/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import Feature from '@modules/utils/feature'
import withBillingDetails from '@modules/billing-lib/billingDetails/withBillingDetails'

import { isFeatureActivated } from '@/selectors/config'
import {
  getAllOrganizationDeploymentsSearchResults,
  searchAllOrganizationDeployments,
} from '@/components/Organization/OrganizationDeployments/lib'
import { fetchMarketplaceBillingDetails } from '@/actions/billing'
import { getMarketplaceBillingDetails } from '@/reducers/billing'
import { fetchMarketplaceBillingDetailsRequest } from '@/reducers/asyncRequests/registry'

import OrganizationOverview from './OrganizationOverview'
import { StateProps, DispatchProps, ConsumerProps } from './types'

import type { ReduxState } from '@/types/redux'

const mapStateToProps = (
  state: ReduxState,
  {
    saasOrganization: {
      organization: { organization_id },
    },
  }: ConsumerProps,
): StateProps => ({
  deploymentsSearchResults: getAllOrganizationDeploymentsSearchResults(state, organization_id),
  enableInvoiceAdminActions: isFeatureActivated(state, Feature.enableInvoiceAdminActions),
  marketplaceBillingDetails: getMarketplaceBillingDetails(state, organization_id),
  fetchMarketplaceBillingDetailsRequest: fetchMarketplaceBillingDetailsRequest(
    state,
    organization_id,
  ),
})

const mapDispatchToProps = (
  dispatch,
  {
    saasOrganization: {
      organization: { organization_id: organizationId },
    },
  }: ConsumerProps,
): DispatchProps => ({
  searchOrganizationDeployments: () =>
    dispatch(
      searchAllOrganizationDeployments({
        organizationId,
      }),
    ),
  fetchMarketplaceBillingDetails: () =>
    dispatch(fetchMarketplaceBillingDetails({ organizationId })),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(withBillingDetails(OrganizationOverview))
